/* eslint-disable vars-on-top */
/* eslint-disable no-implicit-globals */
var mediator = (function() {
  var subscribe = function(tracker, fnc) {
        if (!mediator.trackers[tracker]) {
          mediator.trackers[tracker] = [];
        }

        mediator.trackers[tracker].push({
          context: this,
          callback: fnc
        });

        return this;
      },

      publish = function(tracker) {
        if (!mediator.trackers[tracker]) {
          return false;
        }

        var args = Array.prototype.slice.call(arguments, 1);

        for (var intg = 0, leng = mediator.trackers[tracker].length; intg < leng; intg = intg + 1) {
          var subscription = mediator.trackers[tracker][intg];

          subscription.callback.apply(subscription.context, args);
        }

        return this;
      },

      publishAll = function() {
        if (Object.keys(mediator.trackers).length === 0) {
          return false;
        }

        /* eslint-disable guard-for-in */
        for (var tracker in mediator.trackers) {
          var args = [tracker].concat(Array.prototype.slice.call(arguments));

          mediator.publish.apply(this, args);
        }

        /* eslint-enable guard-for-in */
        return this;
      };

  return {
    trackers: {},
    publish: publish,
    publishAll: publishAll,
    subscribe: subscribe
  };
})();
/* eslint-enable vars-on-top */
/* eslint-enable no-implicit-globals */
